import React, {Component} from 'react';
import Coverflow from 'react-coverflow';
import {StyleRoot} from 'radium';
import {Link} from 'react-router-dom';
import {Col, Row} from 'react-bootstrap';
import "./style.css"

class MainPage extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            carousel_view : []
        }
    }

    generate_mock_data = () => {
        var data = []
        for (let i = 0; i < 10; ++i) {
            data.push(
                <img key={"main-carousel-image"+i} src="https://i.pinimg.com/originals/08/ae/a3/08aea3330b07a52465e9d915f57bc6e0.jpg" alt="failed to load data."/>
                )
        }
        return data;
    }


    render() {
        return (
            <div>
                <Row style={{'backgroundColor': '#f8f8f8'}}>
                    <Col xs={2} >
                    </Col>
                    <Col xs={8} style={{'padding': '20px'}}>
                        <div style={{'display': 'inline-flex'}}>
                            <div style={{'paddingRight': '50px', 'display': 'flex', 'alignItems': 'center'}}>
                                <div>
                                <h2 style={{'fontWeight': 'bold', 'textShadow': '2px 0', 'letterSpacing': '2px'}}>1 million content including images, vectors, icons, fonts, templates and more.</h2>
                                <span>Everything you need as a designer for storytelling</span> <br/><br/>
                                <Link to='/mockupmaker/start/' className="main_page_links" style={{'marginRight': '10px', 'marginTop': '10px'}}>Explore Mockups</Link><br/>
                                <Link to='/designmaker/start/' className="main_page_links" style={{'marginRight': '10px', 'marginTop': '10px'}}>Explore Designs</Link>
                                </div>
                            </div>
                            <StyleRoot>
                            <Coverflow
                                width={'700'}
                                height={'600'}
                                displayQuantityOfSide={1}
                                navigation={false}
                                infiniteScroll
                                enableHeading={false}
                                active={1}
                                currentFigureScale={1.5}	
                                otherFigureScale={0.8}
                                enableScroll={false}
                                >
                                    {this.generate_mock_data()}
                                </Coverflow>
                            </StyleRoot>
                        </div>
                        <img style={{'width': '100%'}} src={global.config.static_file_server_path+"uploads/how_it_works.png"}/>
                        <div style={{'height': '100px'}}>

                        </div>
                        <footer style={{'height': '125px', 'backgroundColor': '#000000',  'padding': '20px', 'position': 'absolute', 'bottom': '0px', 'width': '100%'}}>
                            <div style={{'display': 'inline-flex'}}>
                            <div>
                                <span className="footer_items">About</span>
                                <span className="footer_items">Legal</span>
                                <span className="footer_items">Blog</span>
                                <span className="footer_items">FAQ</span>
                                <span className="footer_items">License</span>
                                <span className="footer_items">Cookie</span>
                                <span className="footer_items">Policy</span>
                                <span className="footer_items">Referal</span>
                            </div>
                            <div style={{'position': 'absolute', 'right': '20px'}}>
                                <i className="fab fa-2x fa-facebook footer_icons"></i>
                                <i className="fab fa-2x fa-instagram footer_icons"></i>
                                <i className="fab fa-2x fa-twitter footer_icons"></i>
                                <i className="fab fa-2x fa-google-plus-g footer_icons"></i>
                            </div>
                            </div>
                            
                            <hr/>
                            
                        </footer>
                    </Col>
                    <Col xs={2}>

                    </Col>
                </Row>
                <Row>

                </Row>
                
            </div>
        );
    }
}

export default MainPage;